export default "__VITE_ASSET__c6899e1a__"